export const accountConstants = {
    GET_ACCOUNT_STRUCTURE_REQUEST: 'GET_ACCOUNT_STRUCTURE_REQUEST',
    GET_ACCOUNT_STRUCTURE_SUCCESS: 'GET_ACCOUNT_STRUCTURE_SUCCESS',
    GET_ACCOUNT_STRUCTURE_FAILURE: 'GET_ACCOUNT_STRUCTURE_FAILURE',

    CREATE_ACCOUNT_REQUEST: 'CREATE_ACCOUNTs_REQUEST',
    CREATE_ACCOUNT_SUCCESS: 'CREATE_ACCOUNT_SUCCESS',
    CREATE_ACCOUNT_FAILURE: 'CREATE_ACCOUNT_FAILURE',

    CREATE_SUB_ACCOUNT_REQUEST: 'CREATE_SUB_ACCOUNT_REQUEST',
    CREATE_SUB_ACCOUNT_SUCCESS: 'CREATE_SUB_ACCOUNT_SUCCESS',
    CREATE_SUB_ACCOUNT_FAILURE: 'CREATE_SUB_ACCOUNT_FAILURE',

    UPDATE_FORMULAS_REQUEST: 'UPDATE_FORMULAS_REQUEST',
    UPDATE_FORMULAS_SUCCESS: 'UPDATE_FORMULAS_SUCCESS',
    UPDATE_FORMULAS_FAILURE: 'UPDATE_FORMULAS_FAILURE',

    UPDATE_ACCOUNTS_REQUEST: 'STRUCTURE_UPDATE_ACCOUNTS_REQUEST',
    UPDATE_ACCOUNTS_SUCCESS: 'STRUCTURE_UPDATE_ACCOUNTS_SUCCESS',
    UPDATE_ACCOUNTS_FAILURE: 'STRUCTURE_UPDATE_ACCOUNTS_FAILURE',

    DELETE_ACCOUNT_REQUEST: 'DELETE_ACCOUNT_REQUEST',
    DELETE_ACCOUNT_SUCCESS: 'DELETE_ACCOUNT_SUCCESS',
    DELETE_ACCOUNT_FAILURE: 'DELETE_ACCOUNT_FAILURE',

    MOVE_ACCOUNT_UP_REQUEST: 'MOVE_ACCOUNT_UP_REQUEST',
    MOVE_ACCOUNT_UP_SUCCESS: 'MOVE_ACCOUNT_UP_SUCCESS',
    MOVE_ACCOUNT_UP_FAILURE: 'MOVE_ACCOUNT_UP_FAILURE',

    MOVE_ACCOUNT_DOWN_REQUEST: 'MOVE_ACCOUNT_DOWN_REQUEST',
    MOVE_ACCOUNT_DOWN_SUCCESS: 'MOVE_ACCOUNT_DOWN_SUCCESS',
    MOVE_ACCOUNT_DOWN_FAILURE: 'MOVE_ACCOUNT_DOWN_FAILURE',

    MOVE_ACCOUNT_LEFT_REQUEST: 'MOVE_ACCOUNT_LEFT_REQUEST',
    MOVE_ACCOUNT_LEFT_SUCCESS: 'MOVE_ACCOUNT_LEFT_SUCCESS',
    MOVE_ACCOUNT_LEFT_FAILURE: 'MOVE_ACCOUNT_LEFT_FAILURE',

    MOVE_ACCOUNT_RIGHT_REQUEST: 'MOVE_ACCOUNT_RIGHT_REQUEST',
    MOVE_ACCOUNT_RIGHT_SUCCESS: 'MOVE_ACCOUNT_RIGHT_SUCCESS',
    MOVE_ACCOUNT_RIGHT_FAILURE: 'MOVE_ACCOUNT_RIGHT_FAILURE',

    INSERT_ACCOUNT_REQUEST: 'INSERT_ACCOUNT_REQUEST',
    INSERT_ACCOUNT_SUCCES: 'INSERT_ACCOUNT_SUCCES',
    INSERT_ACCOUNT_FAILURE: 'INSERT_ACCOUNT_FAILURE',

    CREATE_CUSTOM_TAB_REQUEST: 'CREATE_CUSTOM_TAB_REQUEST',
    CREATE_CUSTOM_TAB_SUCCESS: 'CREATE_CUSTOM_TAB_SUCCESS',
    CREATE_CUSTOM_TAB_FAILURE: 'CREATE_CUSTOM_TAB_FAILURE',

    DELETE_CUSTOM_TAB_REQUEST: 'DELETE_CUSTOM_TAB_REQUEST',
    DELETE_CUSTOM_TAB_SUCCESS: 'DELETE_CUSTOM_TAB_SUCCESS',
    DELETE_CUSTOM_TAB_FAILURE: 'DELETE_CUSTOM_TAB_FAILURE',

    UPDATE_CUSTOM_TAB_REQUEST: 'UPDATE_CUSTOM_TAB_REQUEST',
    UPDATE_CUSTOM_TAB_SUCCESS: 'UPDATE_CUSTOM_TAB_SUCCESS',
    UPDATE_CUSTOM_TAB_FAILURE: 'UPDATE_CUSTOM_TAB_FAILURE',

    CREATE_CUSTOM_TAB_ACCOUNT_REQUEST: 'CREATE_CUSTOM_TAB_ACCOUNT_REQUEST',
    CREATE_CUSTOM_TAB_ACCOUNT_SUCCESS: 'CREATE_CUSTOM_TAB_ACCOUNT_SUCCESS',
    CREATE_CUSTOM_TAB_ACCOUNT_FAILURE: 'CREATE_CUSTOM_TAB_ACCOUNT_FAILURE',

    CREATE_CUSTOM_TAB_SUB_ACCOUNT_REQUEST: 'CREATE_CUSTOM_TAB_SUB_ACCOUNT_REQUEST',
    CREATE_CUSTOM_TAB_SUB_ACCOUNT_SUCCESS: 'CREATE_CUSTOM_TAB_SUB_ACCOUNT_SUCCESS',
    CREATE_CUSTOM_TAB_SUB_ACCOUNT_FAILURE: 'CREATE_CUSTOM_TAB_SUB_ACCOUNT_FAILURE',

    UPDATE_CUSTOM_TAB_ACCOUNT_REQUEST: 'UPDATE_CUSTOM_TAB_ACCOUNT_REQUEST',
    UPDATE_CUSTOM_TAB_ACCOUNT_SUCCESS: 'UPDATE_CUSTOM_TAB_ACCOUNT_SUCCESS',
    UPDATE_CUSTOM_TAB_ACCOUNT_FAILURE: 'UPDATE_CUSTOM_TAB_ACCOUNT_FAILURE',

    MOVE_CUSTOM_TAB_ACCOUNT_UP_REQUEST: 'MOVE_CUSTOM_TAB_ACCOUNT_UP_REQUEST',
    MOVE_CUSTOM_TAB_ACCOUNT_UP_SUCCESS: 'MOVE_CUSTOM_TAB_ACCOUNT_UP_SUCCESS',
    MOVE_CUSTOM_TAB_ACCOUNT_UP_FAILURE: 'MOVE_CUSTOM_TAB_ACCOUNT_UP_FAILURE',

    MOVE_CUSTOM_TAB_ACCOUNT_DOWN_REQUEST: 'MOVE_CUSTOM_TAB_ACCOUNT_DOWN_REQUEST',
    MOVE_CUSTOM_TAB_ACCOUNT_DOWN_SUCCESS: 'MOVE_CUSTOM_TAB_ACCOUNT_DOWN_SUCCESS',
    MOVE_CUSTOM_TAB_ACCOUNT_DOWN_FAILURE: 'MOVE_CUSTOM_TAB_ACCOUNT_DOWN_FAILURE',

    DELETE_CUSTOM_TAB_ACCOUNT_REQUEST: 'DELETE_CUSTOM_TAB_ACCOUNT_REQUEST',
    DELETE_CUSTOM_TAB_ACCOUNT_SUCCESS: 'DELETE_CUSTOM_TAB_ACCOUNT_SUCCESS',
    DELETE_CUSTOM_TAB_ACCOUNT_FAILURE: 'UPDATE_CUSTOM_TAB_ACCOUNT_FAILURE',

    CREATE_CHANGE_IN_ACCOUNT_REQUEST: 'CREATE_CHANGE_IN_ACCOUNT_REQUEST',
    CREATE_CHANGE_IN_ACCOUNT_SUCCESS: 'CREATE_CHANGE_IN_ACCOUNT_SUCCESS',
    CREATE_CHANGE_IN_ACCOUNT_FAILURE: 'CREATE_CHANGE_IN_ACCOUNT_FAILURE',

    CREATE_SEPARATOR_REQUEST: 'CREATE_SEPARATOR_REQUEST',
    CREATE_SEPARATOR_SUCCESS: 'CREATE_SEPARATOR_SUCCESS',
    CREATE_SEPARATOR_FAILURE: 'CREATE_SEPARATOR_FAILURE',

    UPDATE_SEPARATOR_REQUEST: 'UPDATE_SEPARATOR_REQUEST',
    UPDATE_SEPARATOR_SUCCESS: 'UPDATE_SEPARATOR_SUCCESS',
    UPDATE_SEPARATOR_FAILURE: 'UPDATE_SEPARATOR_FAILURE',

    DELETE_SEPARATOR_REQUEST: 'DELETE_SEPARATOR_REQUEST',
    DELETE_SEPARATOR_SUCCESS: 'DELETE_SEPARATOR_SUCCESS',
    DELETE_SEPARATOR_FAILURE: 'DELETE_SEPARATOR_FAILURE',

    MOVE_SEPARATOR_REQUEST: 'MOVE_SEPARATOR_REQUEST',
    MOVE_SEPARATOR_SUCCESS: 'MOVE_SEPARATOR_SUCCESS',
    MOVE_SEPARATOR_FAILURE: 'MOVE_SEPARATOR_FAILURE',

    REORDER_CUSTOM_TABS_REQUEST: 'REORDER_CUSTOM_TABS_REQUEST',
    REORDER_CUSTOM_TABS_SUCCESS: 'REORDER_CUSTOM_TABS_SUCCESS',
    REORDER_CUSTOM_TABS_FAILURE: 'REORDER_CUSTOM_TABS_FAILURE', 
    
    };
